import Vue from "vue";
import { post, fetch, Del, put } from "../../../../ask/axios";
import bus from '../../../../ask/eventBus';

export default {
  components: {},
  data() {
     //收件人信息公司自定义验证规则
     var checkShipCompany = (rule, value, callback) => {
      //  if(this.$route.query.ConsignorID==0){
      //   this.getShipCompanyName().then(Results =>{
      //     if(Results==true){          
      //       return callback(new Error('The shipper company already exists!'));
      //     }else{
      //       callback();
      //     }
      //   }) 
      //  }else{
      //   callback();
      //  }

      if(this.shipDisabled==false){
        this.getShipCompanyName().then(Results =>{
          if(Results==true){          
            return callback(new Error('The shipper company already exists!'));
          }else{
            callback();
          }
        }) 
       }else{
        callback();
       }
             
    };
    return {
      api: {
        url: "",
        param: "",
        data: "",
        response: {},
        message: ""
      },
      showModal:false,//弹框遮罩层
      consigBox:false, //收件弹框
      consigList:[],//收件人弹框列表
      //产品信息弹框
      productBox:false,
      chkAll:false,
      isDisabled:false,
      porductList:[],
      isTrue:false, //是否勾选了产品，才点击确定
      searchInput:'',
      shipDisabled:false, //发件人公司是否禁用，新增发票的时候不禁用，编辑发表的时候禁用

      isDisOrd:false, //是否禁用我的发票订单号输入框==== 和 === 是否禁用收件人目的国家，不能修改目的国家
       //我的发票inupt输入框
      fromInvoInfo:{
        InvoiceNo:'',//我的发票
        DateofExportation:new Date(),
        originalCountry:'China',//原产地
        WaybillNO:'',
        //发件人信息
        shipperCompany:'',
        shipperContact:'',shipperMail:'',shipperIsDefault:false,
        shipperTEL:'',shipperAddr:'',shipperProv:'',shipperProvKey:'',shipperCity:'',shipperCity_Key:'',
        shipperCountry:'',shipperCountry_Key:'',shipperZipCode:'',
        chCityOptions:[],//中国城市数据

        //收件人信息
        consigCompany:'',consigContact:'',consigTEL:'',consigCountry:'',Country_Key:'',consigZipCode:'',consigAddr:'',consigCity:'',consigIsDefault:false,
        countryOptions:[], //海外国家数据
        cityOptions:[],//海外城市数据
        consigID:'',//收件人ID
        
        //产品信息
        goodsInfoList:[
          {Commodity:'',Material:'',Use:'',HSCode:'',Qty:'',UnitPrice:'',Unit:1,}         
        ], 
      },
      QtyUnits:[{val:1,label:'PCS'},{val:2,label:'SET'},{val:3,label:'PKG'},{val:4,label:'KGS'},{val:5,label:'UNIT'}],
      loading:false,

      isShow01:false,
      isShow02:false,
      isShow03:false,

      isBlackName:false,//发件联系人是否是黑名单
      isBlackComp:false,//发件公司是否是黑名单
      transportationID:'',//运输方式

      proDibed:false, //防疫物资下单禁用产品信息，不给编辑
      
    };
  },

  created() {    
    this.getCountryInfo();    
  },
  mounted() {    
    this.getValidation();//验证方法
    //this.$refs.fromInvoInfo.resetFields(); //对整个表单进行重置，将所有字段值重置为初始值并移除校验结果

     //货物运输方式，黑名单接口使用  
     bus.$on('expBaseModeCode',(res)=>{
      this.transportationID=res
    })    
    
  },
  watch: {
  },
  computed: {//计算属性周期函数
  //产品信息总申报价值计算
  totalValue(){
    //        return this.fromInvoInfo.goodsInfoList.map(
    //          row=>row.quantity*row.unitValue).reduce(
    //          (acc, cur) => (parseFloat(cur) + acc), 0)
    let num = 0
    if (this.fromInvoInfo.goodsInfoList) {
      this.fromInvoInfo.goodsInfoList.forEach(e => {
        num += e.Qty * e.UnitPrice
      })
      return num
    }
  },
  },
  methods: { 

    getInitData() {
      let initData ={
        InvoiceNo:'',//我的发票
        DateofExportation:new Date(),
        originalCountry:'China',//原产地
        WaybillNO:'',
        //发件人信息
        shipperCompany:'',
        shipperContact:'',shipperMail:'',shipperIsDefault:false,
        shipperTEL:'',shipperAddr:'',shipperProv:'',shipperProvKey:'',shipperCity:'',shipperCity_Key:'',
        shipperCountry:'',shipperCountry_Key:'',shipperZipCode:'',
        chCityOptions:this.fromInvoInfo.chCityOptions,//中国城市数据

        //收件人信息
        consigCompany:'',consigContact:'',consigTEL:'',consigCountry:'',Country_Key:'',consigZipCode:'',consigAddr:'',consigCity:'',consigIsDefault:false,
        countryOptions:this.fromInvoInfo.countryOptions, //海外国家数据
        cityOptions:this.fromInvoInfo.cityOptions,//海外城市数据
        consigID:'',//收件人ID
        consigEmail:'',//邮件
        
        //产品信息
        goodsInfoList:[
          {Commodity:'',Material:'',Use:'',HSCode:'',Qty:'',UnitPrice:'',Unit:1,}         
        ], 
      };

      return initData;
    },

    //深复制方法
    isType(obj, type){
      return this.getType(obj) === type;
    },
    getType(obj){
      var class2type = {};
      ["Null","Undefined","Number","Boolean","String","Object","Function","Array","RegExp","Date"].forEach(function(item){
          class2type["[object "+ item + "]"] = item.toLowerCase();
      });
      return class2type[Object.prototype.toString.call(obj)] || "object";

    },
    copy(obj){
      //如果obj不是对象，那么直接返回值就可以了
      if(obj == null || typeof obj != "object"){
        return obj;
      }
　　　　//定义需要的局部变量，根据obj的类型来调整target的类型
    var i, target = this.isType(obj,"array") ? [] : {},value,valueType;
    for(i in obj){
        value = obj[i];
        valueType = this.getType(value);
　　　　　　　//只有在明确执行深复制，并且当前的value是数组或对象的情况下才执行递归复制
        if(valueType == "array" || valueType == "object"){
            target[i] = this.copy(value);
        }else{
            target[i] = value;
        }
    }
    return target;
    },

    editData(iFromInvoInfo,ordNo,shipDisabled,DesCounInfo) {
      //let temp = JSON.parse(JSON.stringify(iFromInvoInfo));
     // temp.DateofExportation=new Date(temp.DateofExportation)
      iFromInvoInfo = this.copy(iFromInvoInfo);
      //this.fromInvoInfo = iFromInvoInfo;
      this.shipDisabled=shipDisabled

      this.fromInvoInfo.InvoiceNo=iFromInvoInfo.InvoiceNO

      this.fromInvoInfo.DateofExportation=new Date(iFromInvoInfo.DateofExportation)
      this.fromInvoInfo.originalCountry=iFromInvoInfo.originalCountry
      this.fromInvoInfo.WaybillNO=iFromInvoInfo.WaybillNO 
       //发件人信息
      this.fromInvoInfo.shipperCompany=iFromInvoInfo.shipperCompany 
      this.fromInvoInfo.shipperContact=iFromInvoInfo.shipperContact 
      this.fromInvoInfo.shipperTEL=iFromInvoInfo.shipperTEL 
      this.fromInvoInfo.shipperAddr=iFromInvoInfo.shipperAddr 
      this.fromInvoInfo.shipperProv=iFromInvoInfo.shipperProv 
      this.fromInvoInfo.shipperProvKey=iFromInvoInfo.shipperProvKey 
      this.fromInvoInfo.shipperCity=iFromInvoInfo.shipperCity 
      this.fromInvoInfo.shipperCity_Key=iFromInvoInfo.shipperCity_Key 
      this.getChinaCityInfo(this.fromInvoInfo.shipperCity);//调用城市接口

      //收件人信息
      this.fromInvoInfo.consigCompany=iFromInvoInfo.consigCompany  
      this.fromInvoInfo.consigContact=iFromInvoInfo.consigContact   
      this.fromInvoInfo.consigTEL=iFromInvoInfo.consigTEL  
     
      //订单编辑页面的收件人目的国家为当前渠道国家，并且不能修改
      if(DesCounInfo){
        this.fromInvoInfo.consigCountry=DesCounInfo.desCounNameEn  
        this.fromInvoInfo.Country_Key=DesCounInfo.desCounKey  
      }else{
        this.fromInvoInfo.consigCountry=iFromInvoInfo.consigCountry  
        this.fromInvoInfo.Country_Key=iFromInvoInfo.Country_Key  
      }
      
      this.fromInvoInfo.shipperProvKey=iFromInvoInfo.shipperProvKey 
      this.fromInvoInfo.consigZipCode=iFromInvoInfo.consigZipCode  
      this.fromInvoInfo.consigAddr=iFromInvoInfo.consigAddr  
      this.fromInvoInfo.consigCity=iFromInvoInfo.consigCity 
      this.fromInvoInfo.consigID=iFromInvoInfo.consigID
      this.fromInvoInfo.consigEmail=iFromInvoInfo.consigEmail
      
      //产品信息
      this.fromInvoInfo.goodsInfoList=[]
      let goodsInfo=[]
      // alert(iFromInvoInfo.goodsInfoList.length)      
      
      if (iFromInvoInfo.goodsInfoList) {
        iFromInvoInfo.goodsInfoList.forEach(e =>{
          if(!e.Unit){
            e.Unit=1
          }
          let arrInfo={
           Commodity:e.Commodity, 
           Material:e.Material, 
           Use:e.Use, 
           HSCode:e.HSCode, 
           Qty:e.Qty, 
           UnitPrice:e.UnitPrice, 
           Unit:e.Unit,
          }
          goodsInfo.push(arrInfo)
        })
      }
      
      this.fromInvoInfo.goodsInfoList=goodsInfo

      //console.log('this.fromInvoInfo.shipperCity  '  +   JSON.stringify(this.fromInvoInfo.shipperCity))
      this.getChinaCityInfo(this.fromInvoInfo.shipperCity);//调用城市接口
      this.shipDisabled=shipDisabled
      if(ordNo){
        this.fromInvoInfo.WaybillNO = ordNo 
        this.isDisOrd=true
      }
    },

//赋值方法
setData(ConsigDefaultMsg,ConsignorMsg,porductDefultMsg,myInvoiceInfo,ordNo,shipDisabled,DesCounInfo){
//props:["ConsigDefaultMsg","ConsignorMsg","porductDefultMsg","myInvoiceInfo",""],
  this.shipDisabled=shipDisabled
  this.fromInvoInfo = this.getInitData();

  if(ordNo){
    this.fromInvoInfo.WaybillNO = ordNo 
    this.isDisOrd=true
  }else{
    if(myInvoiceInfo){
      this.fromInvoInfo.WaybillNO=myInvoiceInfo.WaybillNO 
    }
  }

 
  //监听我的发票详情信息赋值到页面中
  if(myInvoiceInfo){
    //console.log('myInvoiceInfo' + JSON.stringify(myInvoiceInfo))
     this.fromInvoInfo.InvoiceNo=myInvoiceInfo.InvoiceNO

      this.fromInvoInfo.DateofExportation=new Date(myInvoiceInfo.DateofExportation)
      this.fromInvoInfo.originalCountry=myInvoiceInfo.CountryofOrigin
      
       //发件人信息
      this.fromInvoInfo.shipperCompany=myInvoiceInfo.ConsignorCompany 
      this.fromInvoInfo.shipperContact=myInvoiceInfo.ConsignorName 
      this.fromInvoInfo.shipperTEL=myInvoiceInfo.ConsignorTel 
      this.fromInvoInfo.shipperAddr=myInvoiceInfo.ConsignorStreet 
      this.fromInvoInfo.shipperProv=myInvoiceInfo.ConsignorProv 
      this.fromInvoInfo.shipperProvKey=myInvoiceInfo.ConsignorProvKey 
      this.fromInvoInfo.shipperCity=myInvoiceInfo.ConsignorCity 
      this.fromInvoInfo.shipperCity_Key=myInvoiceInfo.ConsignorCityKey 
      this.getChinaCityInfo(this.fromInvoInfo.shipperCity);//调用城市接口

      //收件人信息
      //只有默认值的国家和下单的目的国家一致才有默认值，否则没有默认值
      if(this.isDisOrd==true && myInvoiceInfo.ConsigneeCountryKey==DesCounInfo.desCounKey){
        this.fromInvoInfo.consigCompany=myInvoiceInfo.ConsigneeCompany  
        this.fromInvoInfo.consigContact=myInvoiceInfo.ConsigneeName   
        this.fromInvoInfo.consigTEL=myInvoiceInfo.ConsigneeTel  
        this.fromInvoInfo.shipperProvKey=myInvoiceInfo.ConsignorProvKey 
        this.fromInvoInfo.consigZipCode=myInvoiceInfo.ConsigneeZipCode  
        this.fromInvoInfo.consigAddr=myInvoiceInfo.ConsigneeStreet  
        this.fromInvoInfo.consigCity=myInvoiceInfo.ConsigneeCity 
        this.fromInvoInfo.consigID=myInvoiceInfo.ConsigneeID
        this.fromInvoInfo.consigEmail=myInvoiceInfo.ConsigneeEmail
      }else if(this.isDisOrd==false){
        this.fromInvoInfo.consigCompany=myInvoiceInfo.ConsigneeCompany  
        this.fromInvoInfo.consigContact=myInvoiceInfo.ConsigneeName   
        this.fromInvoInfo.consigTEL=myInvoiceInfo.ConsigneeTel  
        this.fromInvoInfo.shipperProvKey=myInvoiceInfo.ConsignorProvKey 
        this.fromInvoInfo.consigZipCode=myInvoiceInfo.ConsigneeZipCode  
        this.fromInvoInfo.consigAddr=myInvoiceInfo.ConsigneeStreet  
        this.fromInvoInfo.consigCity=myInvoiceInfo.ConsigneeCity 
        this.fromInvoInfo.consigID=myInvoiceInfo.ConsigneeID
        this.fromInvoInfo.consigEmail=myInvoiceInfo.ConsigneeEmail
      }
      
       //订单编辑页面的收件人目的国家为当前渠道国家，并且不能修改
       if(DesCounInfo){
        this.fromInvoInfo.consigCountry=DesCounInfo.desCounNameEn  
        this.fromInvoInfo.Country_Key=DesCounInfo.desCounKey  
      }else{
        this.fromInvoInfo.consigCountry=myInvoiceInfo.ConsigneeCountry  
        this.fromInvoInfo.Country_Key=myInvoiceInfo.ConsigneeCountryKey 
      }
           
      //产品信息
      this.fromInvoInfo.goodsInfoList=[] 
      let goodsInfo=[]
      if (myInvoiceInfo.ProductInfos) {
        myInvoiceInfo.ProductInfos.forEach(e =>{
           !e.Unit ? e.Unit=1 : e.Unit=e.Unit
         // if(!e.Unit){e.Unit=1}
          let arrInfo={
           Commodity:e.EnglishName, 
           Material:e.Material, 
           Use:e.Purpose, 
           HSCode:e.CustomsCode, 
           Qty:e.Quanlity, 
           UnitPrice:e.Price, 
           Unit:e.Unit,
          }
          goodsInfo.push(arrInfo)
        })
      }
      
      this.fromInvoInfo.goodsInfoList=goodsInfo
  }
    //订单编辑页面的收件人目的国家为当前渠道国家，并且不能修改
    if(DesCounInfo){
     this.fromInvoInfo.consigCountry=DesCounInfo.desCounNameEn  
     this.fromInvoInfo.Country_Key=DesCounInfo.desCounKey  
     }else{
      if(ConsigDefaultMsg){
        this.fromInvoInfo.consigCountry=ConsigDefaultMsg.RecCountryNameEn  
        this.fromInvoInfo.Country_Key=ConsigDefaultMsg.Country_Key
      }
    }
   //收件人取设为默认的值，赋值到收件人信息中
  if(ConsigDefaultMsg){
    //只有默认值的国家和下单的目的国家一致才有默认值，否则没有默认值
    if(this.isDisOrd==true && ConsigDefaultMsg.Country_Key==DesCounInfo.desCounKey){
      this.fromInvoInfo.consigCompany=ConsigDefaultMsg.company
      this.fromInvoInfo.consigContact=ConsigDefaultMsg.Address_Name
      this.fromInvoInfo.consigTEL=ConsigDefaultMsg.Address_Tel
      // this.fromInvoInfo.consigCountry=ConsigDefaultMsg.RecCountryNameEn
      // this.fromInvoInfo.Country_Key=ConsigDefaultMsg.Country_Key
      this.fromInvoInfo.consigZipCode=ConsigDefaultMsg.Address_ZIPCode
      this.fromInvoInfo.consigAddr=ConsigDefaultMsg.Address_Street
      this.fromInvoInfo.consigCity=ConsigDefaultMsg.Address_City
      this.fromInvoInfo.consigIsDefault=ConsigDefaultMsg.Address_IsDefault
      this.fromInvoInfo.consigID=ConsigDefaultMsg.Address_ID
      this.fromInvoInfo.consigEmail=ConsigDefaultMsg.Address_Mail
    }else if(this.isDisOrd==false ){
      this.fromInvoInfo.consigCompany=ConsigDefaultMsg.company
      this.fromInvoInfo.consigContact=ConsigDefaultMsg.Address_Name
      this.fromInvoInfo.consigTEL=ConsigDefaultMsg.Address_Tel
      // this.fromInvoInfo.consigCountry=ConsigDefaultMsg.RecCountryNameEn
      // this.fromInvoInfo.Country_Key=ConsigDefaultMsg.Country_Key
      this.fromInvoInfo.consigZipCode=ConsigDefaultMsg.Address_ZIPCode
      this.fromInvoInfo.consigAddr=ConsigDefaultMsg.Address_Street
      this.fromInvoInfo.consigCity=ConsigDefaultMsg.Address_City
      this.fromInvoInfo.consigIsDefault=ConsigDefaultMsg.Address_IsDefault
      this.fromInvoInfo.consigID=ConsigDefaultMsg.Address_ID
      this.fromInvoInfo.consigEmail=ConsigDefaultMsg.Address_Mail
    }
      }

 //console.log(ConsignorMsg.company)
  //获取到的发件人信息赋值到我的发票组件中
  if(ConsignorMsg){
    this.fromInvoInfo.shipperCompany=ConsignorMsg.company
    this.fromInvoInfo.shipperContact=ConsignorMsg.Address_Name
    this.fromInvoInfo.shipperTEL=ConsignorMsg.Address_Tel
    this.fromInvoInfo.shipperCountry=ConsignorMsg.SendCountryNameEn
    this.fromInvoInfo.shipperCountry_Key=ConsignorMsg.Country_Key
    this.fromInvoInfo.shipperZipCode=ConsignorMsg.Address_ZIPCode
    this.fromInvoInfo.shipperMail=ConsignorMsg.Address_Mail
    this.fromInvoInfo.shipperAddr=ConsignorMsg.Address_Street
    this.fromInvoInfo.shipperCity=ConsignorMsg.Address_City
    this.fromInvoInfo.shipperCity_Key=ConsignorMsg.City_Key
    this.fromInvoInfo.shipperProv=ConsignorMsg.SendProvinceEn
    this.fromInvoInfo.shipperProvKey=ConsignorMsg.Province_Key
    this.fromInvoInfo.shipperIsDefault=ConsignorMsg.Address_IsDefault
    this.getChinaCityInfo(this.fromInvoInfo.shipperCity);//调用城市接口
 }
 //产品信息的默认值
 
 
 if(this.$route.query.cargoCode){
   //从防疫物资下单购买，默认取值json中的产品信息  
   this.proDibed=true
   this.getProList()
 }else{
   //如果不是防疫物资下单，则取产品信息库中的默认值。
  if(porductDefultMsg && porductDefultMsg.length > 0){
    for(var i=this.fromInvoInfo.goodsInfoList.length-1; i>=0; i-- ){
        let e = this.fromInvoInfo.goodsInfoList[i]
        if(!e.Commodity && !e.Material && !e.Use && !e.HSCode && !e.Qty && !e.UnitPrice){
          this.fromInvoInfo.goodsInfoList.splice(i,1)
        }
      }
      this.fromInvoInfo.goodsInfoList=[]
      porductDefultMsg.forEach(item =>{
        let arr={
          Commodity:item.EnglishName,
          Material:item.Material,
          Use:item.Purpose,
          HSCode:item.CustomsCode,
          Unit:1,
        }
        this.fromInvoInfo.goodsInfoList.push(arr)
      })     
  }

 }

},
     //防疫物资产品信息数据 
     getProList(){//读取产品json
      fetch('/static/data/fyProductData.json').then((res) => {
        //赋值
        res.forEach(item =>{
         
          if(item.AttrVal_Code==this.$route.query.cargoCode){
            let arr={
              Commodity:item.productInfos.EnglishName,
              Material:item.productInfos.Material,
              Use:item.productInfos.Purpose,
              HSCode:item.productInfos.CustomsCode,
              Unit:1,
              Qty:this.$route.query.Qty,
              UnitPrice:item.productInfos.Price
            }            
            this.fromInvoInfo.goodsInfoList=[arr]
          }
        }) 
      })
    },

    ////-----------------------发件人信息方法--------------------------------////
    //发件人公司名重复提示
    async getComName(){
      if(this.shipDisabled==false && this.fromInvoInfo.shipperCompany){
        this.getShipCompanyName();
        await this.IsBlacklistUserApi()
      }
    },
    getShipCompanyName(){
      let that=this
      that.api.param={
        Company:this.fromInvoInfo.shipperCompany
      }
      // that.api.url=that.$api02+'/api/EbayCustomer/Addresser/List'
      that.api.url=that.$api04 + '/Basics/api/Addresser/List';
      post(that.api.url,that.api.param).then(function (res) {
        if(res.Results.length > 0){
            that.isShow01=true      
        }else{
            that.isShow01=false
        }
      })    
    },
    // getShipCompanyName(){
    //   return new Promise(resolve =>{
    //     let that=this
    //     that.api.param={
    //       Company:this.fromInvoInfo.shipperCompany
    //     }
    //     that.api.url=that.$api02+'/api/EbayCustomer/Addresser/List'
    //     post(that.api.url,that.api.param).then(function (res) {
    //       if(res.Results.length > 0){
    //         resolve(true);            
    //       }else{
    //         resolve(false);  
    //       }
    //     })
    //   })      
    // },
    //中国城市数据接口
    getChinaCityInfo(query){
     // console.log('query '  +  query)
      let that=this
      that.api.param={
        "CityName":query,
        "Type":'Ch', //Ch:查中国城市数据  En：查海外城市数据
         "Take":50,
      }
      // that.api.url=that.$api02+'/api/EbayCustomer/City/GetStartCityQuery'
      that.api.url=that.$api04 + '/Basics/api/SysRegion/GetStartCityQuery'
      post(that.api.url,that.api.param).then(function (res) {
        that.fromInvoInfo.chCityOptions=res.Results
        that.loading = false;

        // that.fromInvoInfo.shipperCity_Key=that.fromInvoInfo.shipperCity_Key 
      })
    },

    //发件人城市数据
    shipperRemoteMethod(query){
      if (query != '') {
        this.loading = true;
        this.getChinaCityInfo(query);
      } else {
        this.fromInvoInfo.chCityOptions = [];
      }
    },
    //中国城市值改变
    changeChCityKey(val){
      if(this.fromInvoInfo.chCityOptions){
        this.fromInvoInfo.chCityOptions.forEach(e =>{
          if(e.CityKey==this.fromInvoInfo.shipperCity_Key){
            this.fromInvoInfo.shipperCity=e.CityNameEn
            this.fromInvoInfo.shipperProv=e.Province_NameEn
            this.fromInvoInfo.shipperProvKey=e.ProvinceKey
          }  
        })
      }  
      if(this.fromInvoInfo.shipperCity_Key){
         this.isShow02=false
      }
    },
    
    ////---------------------收件人信息方法--------------------------------////
    //海外国家数据接口
    getCountryInfo(){
      let that=this
      that.api.param={
      }
      // that.api.url=that.$api02+'/api/EbayCustomer/ForeignCity/QueryForeignCountry'
      that.api.url=that.$api04 + "/Basics/api/ForeignCity/QueryForeignCountry";
      fetch(that.api.url,that.api.param).then(function (res) {
        that.fromInvoInfo.countryOptions=res.Results
      })
    },
    // 国家值改变 
    changeCountryKey(item){
      // console.log('item  ' +  JSON.stringify(item)) 
      // console.log('item  ' +  JSON.stringify(this.fromInvoInfo.countryOptions)) 
      if(this.fromInvoInfo.countryOptions){
        this.fromInvoInfo.countryOptions.forEach( e =>{
          if(this.fromInvoInfo.Country_Key==e.CountryKey){
             this.fromInvoInfo.consigCountry=e.NameEn
          }
        })
      }
      //this.fromInvoInfo.Country_Key=item    
      //国家值改变清空城市下拉数据和城市值
      this.fromInvoInfo.cityOptions=[]
      this.fromInvoInfo.consigCity=''

      if(this.fromInvoInfo.Country_Key){
        this.isShow03=false
      }
    },
    //海外城市数据接口
    getCityInfo(query){
      let that=this
      that.api.param={
        countryKey:that.fromInvoInfo.Country_Key,
        cityName:query,
        take:100,
      }
      that.api.url=that.$api02+'/api/EbayCustomer/ForeignCity/QueryForeignCtiy'
      fetch(that.api.url,that.api.param).then(function (res) {
        that.fromInvoInfo.cityOptions=res.Results
        that.loading = false;
      })
    },
    //收件人城市方法
    remoteMethod(query){
      if (query != '') {
        this.loading = true;
        this.getCityInfo(query);
      } else {
        this.fromInvoInfo.cityOptions = [];
      }
    },
    chaneCityKey(){ //城市值改变
      let val=$.trim(this.fromInvoInfo.consigCity)
      if(!val){
        this.fromInvoInfo.cityOptions=[]
        return false
      }else{  
        return true
      }
    },

    //点击收件人信息按钮
    clkConsigAddr(){
      this.showModal=true;
      this.consigBox=true;

      this.getConsigList();
    },
    //收件人信息弹框数据接口
    getConsigList(){
      let that = this;
      if(this.isDisOrd==true){
        that.api.param={
          CountryKey:that.fromInvoInfo.Country_Key,
          Page: 1,
          Size: 99999
        }
      }
      // that.api.url=that.$api02 + '/api/EbayCustomer/Addressee/List';
      that.api.url=that.$api04 + "/Basics/api/Addressee/List";
      post(that.api.url,that.api.param).then(function (res) {
        that.consigList = res.Results;
      })
    }, 
    //收件人弹框选择按钮
    clkSelectAddr(item){
      //consigCompany:'',consigContact:'',consigTEL:'',consigCountry:'',Country_Key:'',consigZipCode:'',consigAddr:'',consigCity:'',
      this.fromInvoInfo.consigCompany=item.company
      this.fromInvoInfo.consigContact=item.Address_Name
      this.fromInvoInfo.consigTEL=item.Address_Tel      
      this.fromInvoInfo.consigZipCode=item.Address_ZIPCode
      this.fromInvoInfo.consigAddr=item.Address_Street

      this.fromInvoInfo.consigCountry=item.Address_Country
      this.fromInvoInfo.Country_Key=item.Country_Key
      this.fromInvoInfo.consigCity=item.Address_City
      this.fromInvoInfo.consigID=item.Address_ID
      this.fromInvoInfo.consigEmail=item.Address_Mail

      this.showModal=false;
      this.consigBox=false;

    },
    
    ////---------------------产品信息方法--------------------------------////
    //产品信息列表增加删除点击图标方法
    addGoods(){
       return {Commodity:'',Material:'',Use:'',HSCode:'',Qty:'',UnitPrice:'',Unit:1}
    },
    clkAddIcon(){
       this.fromInvoInfo.goodsInfoList.push(this.addGoods())
    },
    clkDelIcon(index){
      if(this.fromInvoInfo.goodsInfoList.length > 1){
        this.fromInvoInfo.goodsInfoList.splice(index,1);
      }
    },
    //点击（产品信息PorductInfo）按钮
    clkPorductInfo(){      
      this.showModal=true;
      this.productBox=true;
      this.chkAll=false;
      this.getPorductListAPI();
    },
    //产品信息弹框列表接口
    getPorductListAPI(){ //产品信息库接口数据
      let that=this
      that.api.param={}
      // that.api.url=that.$api02 + '/api/EbayCustomer/BasProduct/Get';
      that.api.url=that.$api04 + "/Basics/api/BasProduct/Get";
      fetch(that.api.url,that.api.param).then(function (res) {
        if(res.Results){
          if(res.Results.length <= 0){
            that.isDisabled=true //全选禁掉
          }else{
            res.Results.forEach(item => {
              that.$set(item, 'Id', item.ID);
            })
            that.porductList=res.Results
            that.isDisabled=false //全选开启
            that.porductList.forEach((item) =>{
              Vue.set(item,'checkStatus',false)
            })
          }
        }
      })
    },
     //全选
     chkAllEvent(val) {
      var that=this;
      that.porductList.forEach(function(chk) {
        chk.checkStatus = that.chkAll
      })
      if(that.chkAll){
        that.isTrue=true
      }else {
        that.isTrue=false
      }
    },
    //单选
    chkStatusEvent() {
      let that=this
      var select = that.porductList.filter(function(chk,k) {
        return chk.checkStatus == true
      })

      select.length == that.porductList.length ? that.chkAll=true:that.chkAll=false
      if(select.length > 0){
        that.isTrue=true
      }else{
        that.isTrue=false
      }
    },
    //确定按钮
    proConfirmBtn(){
      let that=this
      if(that.isTrue==true){
        for(var i=this.fromInvoInfo.goodsInfoList.length-1; i>=0; i-- ){
          let e = this.fromInvoInfo.goodsInfoList[i]
          if(!e.Commodity && !e.Material && !e.Use && !e.HSCode && !e.Qty && !e.UnitPrice){
            this.fromInvoInfo.goodsInfoList.splice(i,1)
          }
        }
        this.porductList.forEach(function(e) {
          if(e.checkStatus==true){            
              let arrInfo={
                Commodity:e.EnglishName,
                Material:e.Material,
                Use:e.Purpose,
                HSCode:e.CustomsCode,
                Unit:1,
              }    
            that.fromInvoInfo.goodsInfoList.push(arrInfo)
          }
        })
      }
    
    this.showModal=false;
    this.productBox=false;
  },
   //产品信息查询接口
   clkSearchBtn(val){
       this.searchPorduct(val)
   },
  searchPorduct(val){
    let that=this
    that.api.param={
      EnglishName:val
    }
    that.api.url=that.$api02 + '/api/EbayCustomer/BasProduct/Query';
    post(that.api.url,that.api.param).then(function (res) {
      that.porductList=res.Results
      that.porductList.forEach(e =>{
        Vue.set(e,'checkStatus',false)
      })

      if(that.porductList.length <=0 ){
        that.isDisabled=true
      }else{
        that.isDisabled=false
      }
    })
  }, 
    //弹框关闭
    getClose(){
      this.showModal=false;
      this.consigBox=false;
      this.productBox=false;
    },
    //验证
    //验证发件人是否是DHL黑名单 isBlackName 
    async chgBlackName(){
      await this.IsBlacklistUserApi()
   },
    async IsBlacklistUserApi(){  //黑名单接口
       let that=this
       let isTrue=false
       that.api.param={
         ModeCode:that.transportationID,//运输方式
         ConsignorName:that.fromInvoInfo.shipperContact, //寄件人名称
         CompanyName:that.fromInvoInfo.shipperCompany,//公司名称
       }
      //  that.api.url=that.$api03+'/api/TradeCustomer/ConsignorBlacklist/IsBlacklistUser';
       that.api.url=that.$api04+'/Basics/api/ConsignorBlacklist/IsBlacklistUser';
      await post(that.api.url,that.api.param).then(function (res) {
           if(res.IsOK){
             if(res.Message=='CS0001'){
                 that.isBlackName=true
                 that.isBlackComp=false
                 isTrue=true
             }else if(res.Message=='CS0002'){
              that.isBlackName=false
              that.isBlackComp=true
              isTrue=true
              }else{
                that.isBlackName=false
                that.isBlackComp=false
                isTrue=false
              }
           }
         })

         return isTrue
     },


    //验证调取
    getValidation(){
      $('#fromInvoInfo').validationEngine();
    },
    submitForm(){
      return $("#fromInvoInfo").validationEngine('validate');
      //$('#form1').validationEngine('validate')
    }, 
    //提交表单的取消按钮
    submitCancel(){
      //隐藏错误提示
      $('#fromInvoInfo').validationEngine("hide");
      this.isBlackName=false
      this.isBlackComp=false
    },
     //-------提交表单的确定按钮------------//
    async submitFormData(){
       let isOk=this.submitForm();
       if(!isOk){
        return false;
       }
       if(this.isShow01==true){
         return false;
       }
       if(!this.fromInvoInfo.shipperCity_Key){
          this.isShow02=true
          return false;
       }
       if(!this.fromInvoInfo.Country_Key){
        this.isShow03=true
        return false;
       }
        //是否是黑名单
        let chgObj= await this.IsBlacklistUserApi();
        if(chgObj){
          return false
        }
       
       this.$emit('invoiceByValue', this.fromInvoInfo)
     }
  //    submitFormData() {
  //     this.$refs.fromInvoInfo.validate((valid) => {
  //       console.log(valid)
  //       if (valid) {
  //        this.$emit('invoiceByValue', this.fromInvoInfo)
  //        return true
  //       } else {
  //         console.log('error submit!!')
  //         return false;
  //       }
  //     });
  //  },    
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/userCenter/myInfo/invoiceInput.js